import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';

import { ReportsService } from '@services/reports.service';
import {
  loadMailingReportsList,
  loadMailingReportsListFailure,
  loadMailingReportsListSuccess,
} from '@store/mailingReports/mailingReports.actions';

@Injectable()
export class MailingReportsEffects {
  private readonly actions$ = inject(Actions);
  private readonly apiService = inject(ReportsService);

  loadMailingReportsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadMailingReportsList),
      mergeMap(() =>
        this.apiService.mailingReportsList().pipe(
          map((list) => loadMailingReportsListSuccess({ list: list })),
          catchError((error) => of(loadMailingReportsListFailure({ error: error.message }))),
        ),
      ),
    ),
  );
}
